import { useEffect, useState } from "react";
import { isEqual, cloneDeep } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import mixpanel from "mixpanel-browser";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useNavigate } from "react-router-dom";

import { MIXPANEL_PRODUCTS_PAGE } from "../../mixpanel/mixpanel_constants";
// import {
//   fetchProducts,
//   updateParams,
//   updateProductPageState,
// } from "./productActions";
import { fetchNotes } from "../../Shared/Notes/NoteActions";
import { usePrevious } from "../../Shared/CustomHooks";
import { addDefaultSrc, deleteValue } from "../../utilities";
import IndexSelectedFilters from "../../Shared/IndexSelectedFilters";
import IndexFilterToggle from "../Components/IndexFilterToggle";
import IndexPagination from "../../Shared/IndexPagination";
import IndexPageGrid from "../Components/IndexPageGrid";
import Filters from "../../Shared/filters";

import "react-loading-skeleton/dist/skeleton.css";
// import "./Components/product.scss";

import { filterNames } from "../../constants";
import HorizontalFilters from "../../Shared/HorizontalFilters/HorizontalFilters";
import { fetchNavbarStats } from "../../vyrill-ui-config/layout/sidebar/navbarStatsActions";
import { Card, Spinner } from "reactstrap";
import {
  ActiveCampgainFooter,
  DraftCampgainFooter,
  PastCampgainFooter,
} from "./Components/Campaign/CampaignCardFooter";
import {
  updateCampaignState as updateVideoCampaignState,
  updateParams,
  updateVideoPageState,
} from "./VideoActions";
import NoCampaignCard from "./Components/Campaign/NoCampaignCard";
import { updateCampaignState as updateCreateCampaignState } from "../CreateCampaign/CampaignActions";

const CampaignIndexContainer = ({ CampaignCards, loading, tab }) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const params = useSelector((state) => state.productParams);
  const currentBrand = useSelector((state) => state.selectedBrandReducer);
  const navbarStatsReducer = useSelector((state) => state.navbarStatsReducer);
  // const loading = useSelector((state) => state.productData?.loading);
  const filters = useSelector((state) => state.productData?.filters);
  const campaigns = useSelector((state) => state.videoPageStates.campaigns);
  const movedToTrash = useSelector(
    (state) => state.productPageStates.movedToTrash
  );
  const removedFromTrash = useSelector(
    (state) => state.productPageStates.removedFromTrash
  );

  const { brand_id } = currentBrand;
  const prevBrandId = usePrevious(brand_id);
  const prevParams = usePrevious(params);
  const preMovedToTrash = usePrevious(movedToTrash);
  const prevremovedFromTrash = usePrevious(removedFromTrash);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleFilters = () => {
    setFiltersOpen(!filtersOpen);
  };

  const truncateName = (name, wordLimit) => {
    const words = name.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return name;
  };

  const handleClick = (campaignName, campaignId) => {
    const truncatedName = truncateName(campaignName, 2);
    // Constructing the URL with query parameters
    if (tab === "DRAFT") {
      const queryParams = new URLSearchParams();
      queryParams.append("id", campaignId);

      // Navigating to the route with the query parameters
      navigate("/create_campaign?" + queryParams.toString());
      dispatch(updateCreateCampaignState({ activeStep: 1 }));
    } else {
      dispatch(
        updateParams({
          tab: "Campaigns",
          transcriptView: false,
          is_widget: false,
          search: "",
          page: 1,
          isTrashTab: false,
          isFlaggedTab: false,
          isFavoriteTab: false,
          isCampaignTab: true,
          campaignId: `${campaignId}`,
        })
      );
      navigate(`/videos/campaigns/${campaignId}`);
      dispatch(
        updateVideoPageState({
          isCampaignListPage: false,
        })
      );

      const campaignPageBreadcrumb = [
        {
          name: "Campaigns",
          tab: "Campaigns",
          type: "tab",
          link: "/videos/campaigns",
          page: "videos",
        },
        {
          name: truncatedName,
          isCampaign: true,
          // tab: "Campaigns",
          // type: "tab",
          link: "",
          // page: "videos",
        },
      ];
      dispatch(
        updateVideoCampaignState({
          campaignName: campaignName,
          campaignId: campaignId,
          breadcrumbs: campaignPageBreadcrumb,
          showCampaignHeader: true,
        })
      );
      dispatch(
        updateParams({
          isCampaignTab: false,
          updateParamsOnly: true,
        })
      );
    }
  };

  useEffect(() => {
    // This code will run when the component mounts
    return () => {
      // This code will run when the component unmounts
      dispatch(
        updateVideoPageState({
          isCampaignListPage: false,
        })
      );
    };
  }, [dispatch]);

  const renderCard = () => {
    const campaignVideoCount = CampaignCards.map(
      (campaign) => campaign.videoCount
    );
    const campaignDetail = CampaignCards.map(
      (campaign) => campaign.campaignDetail
    );
    return campaignDetail.map((campaign, index) => (
      <Card
        key={index}
        className={`CardContent-Campaign-Product`}
        onClick={() => handleClick(campaign?.name, campaign._id)}
      >
        <img
          className="img"
          src={
            campaign?.banner_url ||
            require("@src/assets/images/vyrill/videos/upload_image_video.png")
              .default
          }
          style={{
            objectFit:
              campaign?.bannerRenderAs === "Fill" || campaign?.banner_url === ""
                ? "cover"
                : campaign?.bannerRenderAs === "Fit"
                ? "contain"
                : "contain",
            background: "black",
            overflow: "hidden",
          }}
        />
        <div className="title">{campaign?.name}</div>
        {tab === "ACTIVE" && (
          <ActiveCampgainFooter
            campaign={campaign}
            videoCount={campaignVideoCount[index]}
          />
        )}
        {tab === "PAST" && (
          <PastCampgainFooter
            campaign={campaign}
            videoCount={campaignVideoCount[index]}
          />
        )}
        {tab === "DRAFT" && <DraftCampgainFooter />}
      </Card>
    ));
  };

  return (
    <>
      {/* <HorizontalFilters
        filters={params.filters}
        dismissFilter={dismissFilter}
      /> */}
      <div className={`index-content ${filtersOpen && "content-left"}`}>
        <div className="content-body">
          {/*Sidebar Filter Toggle */}
          {/* <IndexFilterToggle
            filtersOpen={filtersOpen}
            toggleFilters={toggleFilters}
          /> */}
          {CampaignCards.length === 0 && !loading && tab === "ACTIVE" && (
            <div className="d-flex justify-content-center">
              <NoCampaignCard />
            </div>
          )}
          {/* Rendering in Grid Page */}
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "70vh" }}
            >
              <div>
                <Spinner />
              </div>
            </div>
          ) : (
            <div className="IndexPageGrid mt-3">
              <PerfectScrollbar
                className="main-menu-content scroll-container"
                options={{ wheelPropagation: true, maxScrollbarLength: 100 }}
                style={{ marginRight: "-20px" }}
              >
                <div className="grid-container" style={{ marginRight: "20px" }}>
                  {renderCard()}
                </div>
              </PerfectScrollbar>
            </div>
          )}
        </div>

        {/* <IndexPagination
          cardType="Product"
          update={(param) => updatedParams(param)()}
        /> */}
      </div>
      {/* {filtersOpen && (
        <Filters
          filters={filters}
          sort={false}
          desc={params.desc}
          defaultFilter="category"
          selectedFilters={params.filters}
          updateFilters={updateFilters}
          updateParams={updatedParams}
          loading={loading}
          page="products"
          toggleFilters={toggleFilters}
          filtersHeight="65vh"
          indexRedesign
        />
      )} */}
    </>
  );
};

export default CampaignIndexContainer;
